import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { ToastService, Toast } from './services/toast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('toastAnimation', [
      state('void', style({ opacity: 0, transform: 'translateX(100%)' })),
      state('*', style({ opacity: 1, transform: 'translateX(0)' })),
      transition('void => *', animate('300ms ease-out')),
      transition(
        '* => void',
        animate(
          '200ms ease-in',
          style({ opacity: 0, transform: 'translateX(100%)' })
        )
      ),
    ]),
  ],
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  private subscription?: Subscription;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.subscription = this.toastService.toasts$.subscribe(toasts => {
      this.toasts = toasts;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  removeToast(id: string): void {
    this.toastService.remove(id);
  }

  getIcon(variant: string): string {
    const icons: Record<string, string> = {
      success: 'assets/icons/tick-circle.svg',
      warning: 'assets/icons/warning.svg',
      error: 'assets/icons/forbidden-white.svg',
      info: 'assets/icons/info-circle.svg',
    };
    return icons[variant] || 'assets/icons/info-circle.svg';
  }
}
